import { render } from "./DataTable.vue?vue&type=template&id=6930baee&ts=true"
import script from "./DataTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./DataTable.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "/builds/easy/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Components/DataTable.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6930baee"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6930baee', __exports__)) {
    console.log('reload')
    api.reload('6930baee', __exports__)
  }
  
  module.hot.accept("./DataTable.vue?vue&type=template&id=6930baee&ts=true", () => {
    console.log('re-render')
    api.rerender('6930baee', render)
  })

}


export default __exports__